//Copyright Open Trade Technology Ltd. 2023. All rights reserved.

import { Box, CircularProgress, Typography } from '@mui/material'
import { GridSortModel } from '@mui/x-data-grid-premium'
import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'

import { EthAddr } from '@shared/SchemaTypes'

import { useOtChainState, useOtSelector } from '@react/redux/store'

import { SectionHeader } from '@react/components/common/SectionHeader'

import { fetchPoolEventCTOs } from '@react/fetchers/PoolFetchers'
import ReportExplorer from '@react/reporting/ReportExplorer'
import { logOT } from '@shared/loggingShared'
import { ReportDataShape } from '@shared/ReportDefinitionCTO'
import { ETH_ADDR_ZERO } from '@shared/SchemaTypes'
import { PoolEventCTO } from '@shared/sharedTypes'
import { WithdrawEventTypes } from '@shared/templateApx'

export default function BorrowerAdminWithdrawLedger(props: { poolAddr?: EthAddr }): React.ReactElement {
  const [loading, setLoading] = useState<boolean>(false)
  const [fetchDataError, setFetchDataError] = useState<any | undefined>(undefined)
  const poolAddr = (props.poolAddr ? props.poolAddr : useParams().poolAddr) as EthAddr
  const poolOverviewCTO = useOtSelector((state) => state.poolState.poolOverviewCTOs[poolAddr ?? ETH_ADDR_ZERO])

  const {
    stageConfiguration: { restAPIKey, serverApiBaseUrl },
    chainConfiguration: { providerReadOnly },
  } = useOtChainState()
  const [rows, setRows] = useState<PoolEventCTO[]>([])

  useEffect(() => {
    async function fetchEventsForLedger() {
      try {
        setFetchDataError(undefined)
        setLoading(true)
        if (!providerReadOnly || !poolAddr) return

        const events: PoolEventCTO[] = await fetchPoolEventCTOs(serverApiBaseUrl, restAPIKey, poolAddr)
        console.log('events', events)
        const withdrawEvents: PoolEventCTO[] = events.filter((event: PoolEventCTO) => {
          return WithdrawEventTypes.includes(event.eventType)
        })
        console.log('withdrawEvents', withdrawEvents)
        setRows(withdrawEvents)
        setLoading(false)
      } catch (error: any) {
        logOT.error('Error fetching pool events', error)
        setFetchDataError(error)
        setLoading(false)
      }
    }

    fetchEventsForLedger()
  }, [poolAddr, poolOverviewCTO])
  const defaultColumnNames = ['transactionHash', 'eventName', 'timestamp', 'assets', 'shares']
  const defaultSortModel: GridSortModel = [{ field: 'timestamp', sort: 'desc' }]
  return (
    <>
      <SectionHeader>Withdrawal Ledger</SectionHeader>
      {loading && (
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            alignContent: 'center',
            margin: '8px',
          }}
        >
          <Box>
            <CircularProgress />
          </Box>
          <Typography textAlign={'center'} variant="bodyMuted">
            Loading Withdrawal transactions
          </Typography>
        </Box>
      )}
      <ReportExplorer
        sx={{
          marginTop: 2,
        }}
        loading={loading}
        fetchDataError={fetchDataError}
        defaultColumnNames={defaultColumnNames}
        defaultSortModel={defaultSortModel}
        reportDataShape={ReportDataShape.POOL_EVENTS}
        rows={rows}
      />
    </>
  )
}
